export const storeItems = [
  {
    id: 1,
    name: "Follower Egg / 追随者蛋",
    description: "A rare follower egg. Hatch a special minion to help work your farm! 一枚稀有的追随者蛋。孵化出一个特殊的仆从来帮助你耕种农场！",
    image: "/sprites/flame_dragon_egg.png",
    price: '???',
    category: "gacha"
  },
  {
    id: 2,
    name: "Money ¥10,000 / 1万元",
    description: "",
    image: "/sprites/1wy.png",
    price: '???',
    category: "currency"
  },
  {
    id: 2,
    name: "Money ¥100,000 / 10万元",
    description: "",
    image: "/sprites/10wy.png",
    price: '???',
    category: "currency"
  },
  

  // {
  //   id: 2,
  //   name: "100 Carat Emerald",
  //   description: "Premium emeralds to boost your wealth and prestige",
  //   image: "/sprites/items/100_carat_emerald.png",
  //   price: 100,
  //   category: "currency"
  // },
  // {
  //   id: 3,
  //   name: "500 NFTC Pack",

  //   description: "A bundle of 500 NFTC tokens for exclusive purchases",
  //   image: "/sprites/items/500_nftc.png",
  //   price: 500,
  //   category: "currency"
  // },
  // {
  //   id: 4,
  //   name: "Premium Food Pack",
  //   description: "High-quality food to keep your pet happy and healthy",
  //   image: "/sprites/items/premium_food.png",
  //   price: 75,
  //   category: "consumable"
  // },
  // {
  //   id: 5,
  //   name: "Sack of Emeralds",
  //   description: "A hefty sack containing 500 emeralds",
  //   image: "/sprites/items/emerald_sack.png",
  //   price: 1000,
  //   category: "currency"
  // },
  // {
  //   id: 6,
  //   name: "Emerald Pumpkin",
  //   description: "A magical pumpkin worth 2000 emeralds",
  //   image: "/sprites/items/emerald_pumpkin.png",
  //   price: 2000,
  //   category: "special"
  // },
  // {
  //   id: 7,
  //   name: "1000 Carat Emerald",
  //   description: "The ultimate emerald pack for serious collectors",
  //   image: "/sprites/items/1000_carat.png",
  //   price: 1000,
  //   category: "currency"
  // },
  // {
  //   id: 8,
  //   name: "Emerald Bowl",
  //   description: "Contains 50 emeralds in a beautiful decorative bowl",
  //   image: "/sprites/items/emerald_bowl.png",
  //   price: 50,
  //   category: "currency"
  // },
  // {
  //   id: 9,
  //   name: "Rare Fishing Rod",
  //   description: "Catch better fish with this premium fishing rod",
  //   image: "/sprites/items/rare_fishing_rod.png",
  //   price: 250,
  //   category: "tool"
  // },
  // {
  //   id: 10,
  //   name: "Farm Expansion",
  //   description: "Unlock additional farming plots for your homestead",
  //   image: "/sprites/items/farm_expansion.png",
  //   price: 500,
  //   category: "upgrade"
  // },
  // {
  //   id: 11,
  //   name: "Energy Boost Pack",
  //   description: "Instantly restore your pet's energy to maximum",
  //   image: "/sprites/items/energy_boost.png",
  //   price: 150,
  //   category: "consumable"
  // },
  // {
  //   id: 12,
  //   name: "Premium Pet Skin",
  //   description: "Exclusive cosmetic skin for your pet",
  //   image: "/sprites/items/pet_skin.png",
  //   price: 300,
  //   category: "cosmetic"
  // }
];
